export enum PROJECT_INSURANCE_PATHS {
  PROJECT_INSURANCE = "/project-insurance",
  ERECTION_ALL_RISK_INSURANCE = "/project-insurance/erection-all-risk-insurance",
  CONTRACTOR_ALL_RISK_INSURANCE = "/project-insurance/contractor-all-risk-insurance",
  ALOP = "/project-insurance/advance-loss-of-profit-insurance",
  DSU = "/project-insurance/delay-in-start-up-insurance",
  MARINE_CUM = "/project-insurance/marine-cum-erection-insurance",
}
